import { AfterViewInit, ComponentFactoryResolver, ComponentRef, Directive, ElementRef, HostListener, Input, Renderer2, ViewContainerRef } from '@angular/core';
import { TooltipComponent } from 'src/app/component/shared/tooltip/tooltip.component';

@Directive({
  selector: '[appTooltip]'
})
export class TooltipDirective {
  @Input('appTooltip') tooltipContent: any;
  cardElementGridColumn;
  previousValue;

  private tooltipComponentRef: ComponentRef<TooltipComponent>;
  private tooltipOffset = 10; // Offset for tooltip positioning

  constructor(
    private el: ElementRef,
    private viewContainerRef: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private renderer: Renderer2
  ) {
  }


  @HostListener('mouseenter', ['$event'])
  onMouseEnter(event: MouseEvent) {
    this.cardElementGridColumn = this.el.nativeElement.style.gridColumn;
    let [beforeSpan, afterSpan] = this.el.nativeElement.style.gridColumn.split('span');

    if (parseInt(afterSpan.trim()) < 12) {
      this.el.nativeElement.style.gridColumn = `${beforeSpan}span 12`;
    }

    // Dynamically create the tooltip component
    const factory = this.componentFactoryResolver.resolveComponentFactory(
      TooltipComponent
    );
    this.tooltipComponentRef = this.viewContainerRef.createComponent(factory);

    // Pass the data to the tooltip component
    this.tooltipComponentRef.instance.trip = this.tooltipContent.trip;
    this.tooltipComponentRef.instance.spaceType = this.tooltipContent.spaceType;
    this.tooltipComponentRef.instance.los = this.tooltipContent.los;
    this.tooltipComponentRef.instance.fundingSource = this.tooltipContent.fundingSource;
    this.tooltipComponentRef.instance.assist = this.tooltipContent.assist;

    // Position the tooltip
    const tooltipElement = this.tooltipComponentRef.location.nativeElement as HTMLElement;
    tooltipElement.classList.add('absolute', 'text-[12px]', 'rounded-lg', 'm-2' ,  'pointer-events-none', 'transition-all', 'duration-200', 'ease-in-out', 'z-[9999]', 'w-64', 'ring-2', 'ring-main-primary');

    this.setPosition(event, tooltipElement);

    // Add it to the DOM
    this.renderer.appendChild(document.body, tooltipElement);

  }

  @HostListener('mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (this.tooltipComponentRef) {
      const tooltipElement = this.tooltipComponentRef.location.nativeElement;
      this.setPosition(event, tooltipElement);
    }
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    if (this.tooltipComponentRef) {
      this.el.nativeElement.style.gridColumn = this.cardElementGridColumn;
      this.viewContainerRef.clear();
      this.tooltipComponentRef = null;
    }
  }

  private setPosition(event: MouseEvent, tooltipElement: HTMLElement) {
    const pageWidth = window.innerWidth;
    const pageHeight = window.innerHeight;
    const tooltipRect = tooltipElement.getBoundingClientRect();

    // Default positions
    let top = event.pageY + this.tooltipOffset;
    let left = event.pageX + this.tooltipOffset;

    // Check for available space on all sides
    const fitsBelow = top + tooltipRect.height <= pageHeight;
    const fitsAbove = top - tooltipRect.height >= 0;
    const fitsRight = left + tooltipRect.width <= pageWidth;
    const fitsLeft = left - tooltipRect.width >= 0;

    // Determine the best position based on available space
    if (fitsBelow) {
      // Position below the element
      top = event.pageY + this.tooltipOffset;
    } else if (fitsAbove) {
      // Position above the element
      top = event.pageY - tooltipRect.height - this.tooltipOffset;
    }

    // Check horizontal positioning after deciding vertical position
    if (fitsRight) {
      // Position to the right of the element
      left = event.pageX + this.tooltipOffset;
    } else if (fitsLeft) {
      // Position to the left of the element if not enough space on the right
      left = event.pageX - tooltipRect.width - this.tooltipOffset;
    } else {
      // If neither left nor right fits, position center if below or above
      left = event.pageX - (tooltipRect.width / 2);
    }

    // Apply calculated positions
    tooltipElement.style.top = `${top}px`;
    tooltipElement.style.left = `${left}px`;
  }

}
